export default "__VITE_ASSET__sz6U1Jwa__"